module.exports = __webpack_public_path__ + "media/images/pages/careers-week/sam-58bb06fa94d551814db1e1cd4838ca79.jpg";